module.exports = {
  siteTitle: 'Voodoo Shipping Company', // <title>
  manifestName: 'Voodoo Shipping Company',
  manifestShortName: 'VCO', // max 12 characters
  manifestStartUrl: '/',
  manifestBackgroundColor: '#663399',
  manifestThemeColor: '#663399',
  manifestDisplay: 'standalone',
  manifestIcon: 'src/assets/images/website-icon.png',
  pathPrefix: `/vco-website-chaos/`, // This path is subpath of your hosting https://domain/portfolio
  heading: 'Voodoo Shipping Company',
  subHeading: 'The gaming community delivering the most tyranny and servitude since 2010',
  // social
  socialLinks: [
    {
      style: 'brands',
      icon: 'fa-discord',
      name: 'Discord',
      url: 'https://discord.gg/vco',
    },
    {
      style: 'brands',
      icon: 'fa-teamspeak',
      name: 'TeamSpeak',
      url: 'ts3server://ts.voodooshipping.net',
    },
    {
      style: 'brands',
      icon: 'fa-youtube',
      name: 'YouTube',
      url: 'https://www.youtube.com/c/voodooshipping',
    },
    {
      style: 'brands',
      icon: 'fa-twitch',
      name: 'Twitch',
      url: 'https://www.twitch.tv/voodooshipping',
    },
    {
      style: 'brands',
      icon: 'fa-twitter',
      name: 'Twitter',
      url: 'https://twitter.com/VoodooShipCo',
    },
    {
      style: 'brands',
      icon: 'fa-steam',
      name: 'Steam',
      url: 'https://steamcommunity.com/groups/voodooshipping',
    },
    {
      style: 'brands',
      icon: 'fa-paypal',
      name: 'PayPal',
      url: 'https://paypal.me/voodooshippingco',
    },
  ],
};
